import { btnStyle } from '@bingads-webui-campaign/shared-image-experience-styles';

export const getMediaSourcesContainerStyles = (_, { palette = {} }) => ({
  container: {
    paddingBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: palette.neutralLight,
    borderBottomStyle: 'solid',

    '& .media-sources-container': {
      display: 'flex',
    },

    '& .file-drag-container': {
      '& .file-picker-react-wrapper': {
        '& .file-picker-btn': {
          extend: btnStyle()['.btn-default'],
          display: 'inline-block',
          float: 'none',
          marginLeft: 0,

          '& ~ .file-text': {
            display: 'inline-block',
            border: 'none',
          },
        },
      },
      '& .file-picker-react-wrapper.disabled': {
        visibility: 'hidden',
      },
      '& .file-drag-wrapper': {
        height: 111,
        '& .file-default-wrapper': {
          display: 'block',
          paddingLeft: 32,
          paddingTop: 24,
          '& .file-upload-icon': {
            display: 'none',
          },
          '& .file-upload-text': {
            display: 'inline-block',
          },
        },
      },
    },
  },
  mediaSources: {
    alignItems: 'flex-start',
    marginRight: 24,
  },
  mediaSourceLabel: {
    display: 'block',
    textAlign: 'center',
    fontSize: 14,
    lineHeight: '19px',
    color: palette.neutralPrimary,
    fontWeight: 600,
    paddingTop: 6,
  },
  mediaSource: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 12,
    paddingRight: 12,
    alignSelf: 'unset',
    flexBasis: 0,
  },
});

export const getPanelStyles = (components, { palette = {} } = {}) => ({
  panel: {
    top: 60,
  },
  subtitle: {
    paddingTop: 22,
    color: palette.neutralDark,
  },
  panelHeader: {
    paddingLeft: 24,
    paddingRight: 24,
    alignSelf: 'justify-start',
    flexGrow: 1,
  },
  panelTitle: {
    fontSize: 20,
    fontWeight: 600,
    display: 'inline-block',
    lineHeight: '27px',
  },
  backButton: {
    display: 'inline-block',
    paddingRight: 10,
  },
  errorMessage: {
    display: 'block',
    fontSize: '12px',
    color: palette.red,
    marginBottom: 12,
  },
  applyButton: {
    marginRight: 12,
  },
  selectionInfoText: {
    marginLeft: 12,
    display: 'inline-block',
  },
});
